import React, { useState } from "react";
import { styled } from "@mui/system";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import footerLogo from "./assets/conas_logo.png";
import {
  termsAndConditions,
  Acknowledgements,
} from "../gln/assets/VarConstants";

// Styled components for the footer and its elements
const StyledFooter = styled("div")({
  backgroundColor: "#fff",
  color: "#333",
  padding: "0.5em",
  textAlign: "center",
  zIndex: 9999,
  marginTop: "10px",
  position: "relative",
  boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
});

const StyledFooterContent = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  position: "relative",
  "@media (max-width: 600px)": {
    height: "9em",
    flexDirection: "column",
    alignItems: "center",
  },
});

const FooterLink = styled("div")({
  margin: "0 15px",
  color: "#333",
});

const StyledFooterImage = styled("img")({
  width: "6.25em",
  height: "auto",
  marginRight: "0.18em",
});

const FooterText = styled(Typography)({
  margin: "0.31em",
  fontWeight: "bold",
});

const StyledAcceptButton = styled(Button)({
  backgroundColor: "#000",
  color: "#fff",
  margin: "1em auto",
  width: "150px",
  "&:hover": {
    backgroundColor: "#6c757d",
  },
});

const StyledDialogTitle = styled(DialogTitle)({
  textAlign: "center",
  fontWeight: "bold",
});

const StyledDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  overflowY: "auto",
  maxHeight: "44vh",
  maxWidth: "80vw",
});

const DevelopedByContainer = styled("div")({
  position: "absolute",
  right: "1em",
  bottom: "0.92em",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  "@media (max-width: 600px)": {
    position: "relative",
    bottom: "initial",
    right: "initial",
    width: "100%",
    justifyContent: "center",
    marginTop: "1em",
  },
});

const Footer = () => {
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const [openAcknowledgementsModal, setOpenAcknowledgementsModal] =
    useState(false);

  // Functions to handle opening and closing of modals
  const handleOpenTermsModal = (event) => {
    event.preventDefault();
    setOpenTermsModal(true);
  };

  const handleOpenAcknowledgementsModal = (event) => {
    event.preventDefault();
    setOpenAcknowledgementsModal(true);
  };

  const handleCloseModal = () => {
    setOpenTermsModal(false);
    setOpenAcknowledgementsModal(false);
  };

  // Component to render the terms and conditions content
  const DisclaimerContent = () => (
    <Typography style={{ whiteSpace: "pre-line" }}>
      {termsAndConditions}
    </Typography>
  );

  // Component to render the acknowledgements content
  const AcknowledgementsContent = () => (
    <Typography style={{ whiteSpace: "pre-line" }}>
      {Acknowledgements}
    </Typography>
  );

  return (
    <StyledFooter>
      <StyledFooterContent>
        {/* Link to open Terms & Conditions modal */}
        <FooterLink>
          <p>
            By using this service you accept the{" "}
            <span style={{ fontWeight: "bold" }}>
              <a
                href="#"
                onClick={handleOpenTermsModal}
                style={{ color: "#333", textDecoration: "underline" }}
              >
                Terms & Conditions
              </a>
            </span>
            ; click the link to see the details.
          </p>
        </FooterLink>
        {/* Link to open Acknowledgements modal */}
        <FooterLink>
          <p>
            <span style={{ fontWeight: "bold" }}>
              <a
                href="#"
                onClick={handleOpenAcknowledgementsModal}
                style={{ color: "#333", textDecoration: "underline" }}
              >
                Acknowledgements
              </a>
            </span>
          </p>
        </FooterLink>
      </StyledFooterContent>

      {/* Dialog for Terms & Conditions */}
      <Dialog open={openTermsModal} onClose={handleCloseModal}>
        <StyledDialogTitle>Disclaimer</StyledDialogTitle>
        <StyledDialogContent>
          <DisclaimerContent />
          <StyledAcceptButton onClick={handleCloseModal}>
            Accept
          </StyledAcceptButton>
        </StyledDialogContent>
      </Dialog>

      {/* Dialog for Acknowledgements */}
      <Dialog open={openAcknowledgementsModal} onClose={handleCloseModal}>
        <StyledDialogTitle>Acknowledgements</StyledDialogTitle>
        <StyledDialogContent>
          <AcknowledgementsContent />
          <StyledAcceptButton onClick={handleCloseModal}>
            Close
          </StyledAcceptButton>
        </StyledDialogContent>
      </Dialog>
    </StyledFooter>
  );
};

export default Footer;
